import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { EmployeePulseIcon } from 'modules/engagement/components/EmployeePulseIcon'

export const PULSE_ANSWER_FILTER_IDENTIFIER = 'pulseAnswerFilter'

const pulseAnswerFilter = (source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.employee_pulse'),
    path: 'pulseAnswer',
    identifier: PULSE_ANSWER_FILTER_IDENTIFIER,
    type: FilterType.String,
    default: false,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: [
          {
            label: i18n.t('engagement.employee_pulse_labels.no_data'),
            value: '',
            component: (
              <Box flexDirection="row" gap="s6">
                <Box width="s24" height="s24" alignItems="center" justifyContent="center">
                  <Box
                    width="s16"
                    height="s16"
                    background="grey300"
                    borderRadius={{ all: 'rel1000' }}
                  />
                </Box>
                <Text.Normal>{i18n.t('engagement.employee_pulse_labels.no_data')}</Text.Normal>
              </Box>
            ),
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.1'),
            value: '1',
            component: <EmployeePulseIcon mood={1} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.2'),
            value: '2',
            component: <EmployeePulseIcon mood={2} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.3'),
            value: '3',
            component: <EmployeePulseIcon mood={3} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.4'),
            value: '4',
            component: <EmployeePulseIcon mood={4} withLabel />,
          },
          {
            label: i18n.t('engagement.employee_pulse_labels.5'),
            value: '5',
            component: <EmployeePulseIcon mood={5} withLabel />,
          },
        ],
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: PULSE_ANSWER_FILTER_IDENTIFIER,
        value,
      })
    },
  })
}

export default pulseAnswerFilter
